import React from "react";
import { useLang } from "./LanguageProvider";

export default function Partners() {
  const { t, isRtl } = useLang();
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative bg-brand-navy py-24 md:py-32 border-t border-white/5"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-brand-teal" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-brand-teal font-semibold">
                {t.partners.overline}
              </span>
            </div>
            <h2 className="font-heading text-white text-3xl sm:text-4xl md:text-5xl leading-[1.05] font-medium tracking-tight">
              {t.partners.title}
            </h2>
            <p className={`mt-6 text-white/65 text-base md:text-lg leading-relaxed ${isRtl ? "text-right" : "text-left"}`}>
              {t.partners.body}
            </p>
          </div>

          <div className="lg:col-span-6 reveal reveal-delay-1">
            <div className="rounded-xl border border-white/10 bg-brand-surface p-10 md:p-14 flex flex-col items-center justify-center text-center">
              <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-6">
                Technology Partner
              </div>
              <div className="font-heading text-white text-3xl md:text-4xl lg:text-5xl tracking-tight">
                Lubrizol
              </div>
              <div className="text-brand-teal text-xs uppercase tracking-[0.3em] mt-2 font-semibold">
                Corporation · USA
              </div>
              <div className="hairline w-32 mt-7 mb-7" />
              <div className="text-white/55 text-sm max-w-sm leading-relaxed">
                Inventor of FlowGuard™ CPVC, 1959. Direct compound supply &amp; processing technology partnership.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
